<div class="card card-custom" style="height: 100%">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-title align-items-start flex-column">
        <span class="font-weight-bolder text-dark">{{ getTitle() }}</span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm">
          <div class="d-flex align-items-center flex-wrap">
            <span class="text-muted mr-5 font-weight-bold font-size-sm gl-block">
              Patient:
              {{
                data.patient.first_name +
                  ' ' +
                  data.patient.middle_name +
                  ' ' +
                  data.patient.last_name +
                  ' ' +
                  data.patient.last_name2
              }}
            </span>
            <span class="text-muted mr-5 font-weight-bold font-size-sm">
              Category: {{ data.drp.category }}
            </span>
            <span class="text-muted mr-5 font-weight-bold font-size-sm">
              Source: {{ data.drp.source }}
            </span>
            <span class="text-muted mr-5 font-weight-bold font-size-sm">
              PCNE Code: {{ data.drp.problem_code }}
            </span>
          </div>
        </span>
      </h3>
    </div>
  </div>
  <div class="navi-hover scroll card-body" style="max-height: 80vh">
    <div *ngIf="data.from === 'later_date'" class="row">
      <div class="col-lg-7">
        <dl class="row">
          <dt class="col-sm-3 py-2">DRP Title:</dt>
          <dd class="col-sm-9 py-2">{{ data.drp.title }}</dd>

          <dt class="col-sm-3 py-2">DRP Text</dt>
          <dd class="col-sm-9 py-2">{{ data.drp.text }}</dd>
        </dl>
      </div>
      <div class="col-lg-5">
        <form class="form form-group-seperator-dashed" [formGroup]="laterForm">
          <div class="row">
            <div class="col-lg-12 kt-margin-bottom-20-mobile mb-3">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label>Reason</mat-label>
                <mat-select formControlName="reason">
                  <mat-option *ngFor="let reason of reasons" [value]="reason.id">{{
                    reason.reason
                  }}</mat-option>
                </mat-select>
                <mat-error *ngIf="isControlHasError('reason', 'required')">
                  Reason is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile mb-3">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>Note</mat-label>
                <textarea matInput formControlName="note" rows="4"></textarea>
                <mat-error *ngIf="isControlHasError('note', 'required')">
                  Note is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>
        <h5>Review again in:</h5>
        <mat-button-toggle-group aria-label="Type" [formControl]="durationCtrl">
          <mat-button-toggle value="3">3 Months </mat-button-toggle>
          <mat-button-toggle value="6">6 Months </mat-button-toggle>
          <mat-button-toggle value="12">12 Months </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <div *ngIf="data.from === 'ignore'" class="row">
      <div class="col-lg-12">
        <form class="form form-group-seperator-dashed" [formGroup]="laterForm">
          <div class="row">
            <div class="col-lg-12 kt-margin-bottom-20-mobile mb-3">
              <mat-form-field appearance="fill" class="mat-form-field-fluid">
                <mat-label>Reason</mat-label>
                <mat-select formControlName="reason">
                  <mat-option *ngFor="let reason of reasons" [value]="reason.id">{{
                    reason.reason
                  }}</mat-option>
                </mat-select>
                <mat-error *ngIf="isControlHasError('reason', 'required')">
                  Reason is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-12 kt-margin-bottom-20-mobile mb-3">
              <mat-form-field class="mat-form-field-fluid" appearance="fill">
                <mat-label>Note</mat-label>
                <textarea matInput formControlName="note" rows="4"></textarea>
                <mat-error *ngIf="isControlHasError('note', 'required')">
                  Note is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="row">
      <div class="col-lg-9"></div>
      <div class="col-lg-3" style="text-align: right">
        <button
          type="submit"
          mat-raised-button
          color="primary"
          (click)="save()"
          matTooltip="Save changes"
        >
          <span translate="GLOBAL.SAVE">Save</span>
        </button>
      </div>
    </div>
  </div>
</div>
